import CloseIcon from "@mui/icons-material/CloseRounded";
import type { SnackbarCloseReason } from "@mui/material";
import { IconButton, Snackbar } from "@mui/material";
import type { SyntheticEvent } from "react";
import { useCallback } from "react";
import { useNotificationContext } from "../contexts/NotificationContext";

export const GlobalNotificationErrorSnackbar = () => {
  const { notificationError, onCloseNotificationError } = useNotificationContext();

  const handleClose = useCallback(
    (_: Event | SyntheticEvent<unknown, Event>, reason: SnackbarCloseReason) => {
      if (reason !== "clickaway") {
        onCloseNotificationError();
      }
    },
    [onCloseNotificationError]
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={notificationError !== undefined}
      autoHideDuration={notificationError?.autoHideDuration}
      onClose={handleClose}
      message={notificationError?.text}
      sx={(theme) => ({
        ".MuiPaper-root": {
          backgroundColor: theme.palette.error.main,
          flexWrap: "nowrap",
        },
      })}
      action={
        <IconButton color="inherit" onClick={onCloseNotificationError}>
          <CloseIcon />
        </IconButton>
      }
    />
  );
};

export default GlobalNotificationErrorSnackbar;
